module.exports = require("npm:json-pointer@0.3.0/index");